<template>
  <div class="container-fluid adp-admin-container-fluid">
    <button type="button" class="btn adp-btn mr-1" @click="createProvider">
      {{ $t('admin.add_provider') }}
    </button>

    <div v-if="loading">{{ $t('voc.loading') }}</div>
    <div class="adp-grid-table" v-if="!loading">
      <div class="adp-grid-row adp-grid-row__providers">
        <div class="d-flex flex-column adp-grid-cell__head" style="padding: 0 16px">
          <span class="adp-th">{{ $t('admin.russian') }}</span>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <span class="adp-th">{{ $t('admin.english') }}</span>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <span class="adp-th">{{ $t('admin.french') }}</span>
        </div>
      </div>
      <div class="adp-grid-row adp-grid-row__providers" v-for="(item, i) in providers" :key="i"
           @mouseenter="enterToListItem(i)" @mouseleave="leaveFromListItem()"
           :style="currentItemIndex === i ? 'backgroundColor: #F5F5F5' : ''">
        <div class="adp-grid-cell adp-grid-cell__code align-self-baseline" style="padding: 0 16px">
          {{ item.name_ru }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title align-self-baseline">
          {{ item.name_en }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title align-self-baseline">
          {{ item.name_fr }}
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <div class="mr-5" v-if="currentItemIndex === i">
            <img src="/images/delete.svg" style="width: 17px; cursor: pointer; margin-right: 15px" @click="deleteProvider(item)">
            <img src="/images/edit.svg" style="width: 17px; cursor: pointer" @click="renameProvider(item)">
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <rename-provider-modal :provider="selectedProvider" @provider-renamed="getProviders()" />
    <delete-provider-question-modal  :provider="selectedProvider" @provider-deleted="getProviders()" />
    <create-provider-modal @provider-created="getProviders()" />
    <reports-modal v-show="isReportsOpened" :is-reports-opened="isReportsOpened" @close-reports-modal="isReportsOpened = false"/>
  </div>
</template>

<script>
import api from "../../api";
import RenameProviderModal from "./RenameProviderModal";
import DeleteProviderQuestionModal from "./DeleteProviderQuestionModal";
import CreateProviderModal from "./CreateProviderModal";
import ReportsModal from "../modals/ReportsModal.vue";

export default {
  name: "Providers",
  components: {CreateProviderModal, DeleteProviderQuestionModal, RenameProviderModal, ReportsModal},
  data: () => {
    return {
      reportsButton: document.getElementById('reports-download'),
      reportsLoadingButton: document.getElementById('reports-download-circle'),
      isReportsOpened: false,

      loading: false,
      providers: [],
      currentItemIndex: null,
      selectedProvider: {},
    }
  },
  methods: {
    async getProviders() {
      this.$bvModal.hide('create-provider-modal')
      this.$bvModal.hide('rename-provider-modal');
      this.$bvModal.hide('delete-provider-question-modal');
      const resp = await api.getProviders()
      this.providers = resp.data.data;
    },
    enterToListItem(index) {
      this.currentItemIndex = index;
    },
    leaveFromListItem() {
      this.currentItemIndex = null;
    },
    deleteProvider(provider) {
      this.selectedProvider = provider;
      this.$nextTick(() => this.$bvModal.show('delete-provider-question-modal'));
    },
    renameProvider(provider) {
      this.selectedProvider = provider;
      this.$nextTick(() => this.$bvModal.show('rename-provider-modal'));
    },
    createProvider() {
      this.$bvModal.show('create-provider-modal');
    },
  },
  async mounted() {
    this.reportsButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;
    this.reportsLoadingButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;

    await this.getProviders();
  }
}
</script>

<style>

</style>
